import { section } from '@/glow';
import { AnimateImageWithText } from '@/lib/animation';

section('image-with-text', {
  onLoad() {
    this.AnimateImageWithText = AnimateImageWithText(this.container);
  },

  onUnload() {
    this.AnimateImageWithText?.destroy();
  }
});
